module.exports = __webpack_public_path__ + "img/icon8.50dedeb8.png";